import phpClient from '../phpAPI_Config'
import { tsWhoAmI } from '../../../Typescript/API_Response'

async function get(authState: any, path: string) {
  return await phpClient(authState)
    .get<any>('/json/stuart/sample' + path)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function post(authState: any, path: string, payload?: any) {
  return await phpClient(authState)
    .post<any>(`/json/stuart/sample` + path, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function updateSampleResultsBulk(
  authState: tsWhoAmI,
  result: string,
  ids: string[],
) {
  return await phpClient(authState)
    .post<any>('/json/stuart/sample/bulkUpdateSampleResults.php', {
      Result: result,
      SampleIDs: ids,
    })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function updateSampleResultComment(
  authState: tsWhoAmI,
  comment: string,
  id: string,
) {
  return await phpClient(authState)
    .get<any>(
      `/json/stuart/sample/updateSampleResultComment.php?SampleID=${id}&ResultComments=${comment}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}
const SampleService = {
  get,
  post,
  updateSampleResultsBulk,
  updateSampleResultComment,
}

export default SampleService
